import React, { useEffect, useState } from 'react';

export default function GoldPrice() {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-halloween-orange/30 shadow-halloween-purple/10 p-4 w-full">
      <h2 className="font-semibold text-lg mb-2">Giá vàng hôm nay</h2>
      <iframe
        src="https://chogia.vn/ma-nhung-cho-iframe?ma=gold"
        width="100%"
        height="200"
        className="border-none"
        title="Gold Prices"
        loading="lazy"
      ></iframe>
    </div>
  );
}
